<template>
  <div class="tw-grid tw-grid-rows-1 tw-h-full content-scroll">
    <StudyConsentView
      v-if="studyConsent !== undefined"
      class="content-scroll"
      :data-study-consent="studyConsent"
      :data-give-consent-url="giveConsentUrl"
      @download-consent="onDownloadConsent"
      @to-study-consents="onToStudyConsents"
    />
    <ErrorAlert v-if="!!error" :data-error="error" />
  </div>
</template>
<script setup lang="ts">
import StudyConsentView from "./StudyConsentView.vue";
import { useAsyncState } from "@vueuse/core";
import { useRoute, useRouter } from "vue-router";
import _noop from "lodash/fp/noop";
import { patientHttpService } from "./store/patient-http-service";
import {
  studyConsentDownload,
  studyConsentGiveUrl,
} from "./store/study-consent";
import ErrorAlert from "../../design-system/ErrorAlert.vue";
import { locationOf, ROUTES } from "../routing/routes";

const route = useRoute();
const router = useRouter();
const studyConsentId = route.params["studyConsentId"];
const { state: studyConsent, error } = useAsyncState(
  patientHttpService
    .get(`/v1/study-consents/${studyConsentId}`)
    .then((response) => response.data.data),
  undefined,
);
const onDownloadConsent = studyConsentDownload;
const giveConsentUrl = studyConsentGiveUrl(
  { id: studyConsentId },
  { callbackUrl: route.fullPath },
);
const onToStudyConsents = () => {
  router.push(locationOf(ROUTES["patient.studyConsents"], {})).catch(_noop);
};
</script>
